/** Billing / subscription DTOs used by the platform frontend. */

function toDate(value: any): Date | null {
  if (!value) return null;
  const d = value instanceof Date ? value : new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function CreditBalance(data: Record<string, any> = {}) {
  return {
    amount: data.amount || 0,
    currency: data.currency || 'EUR',
    updated_at: data.updated_at || null,
  };
}

export function SubscriptionSchedule(data: Record<string, any> = {}) {
  return {
    stripe_schedule_id: data.stripe_schedule_id || null,
    pending_plan_type: data.pending_plan_type || null,
    pending_price_id: data.pending_price_id || null,
    applies_at: toDate(data.applies_at),
  };
}

export function Subscription(data: Record<string, any> = {}) {
  return {
    id: data.id || null,
    user_id: data.user_id || null,
    stripe_subscription_id: data.stripe_subscription_id || null,
    stripe_customer_id: data.stripe_customer_id || null,
    plan_type: data.plan_type || null,
    stripe_price_id: data.stripe_price_id || null,
    status: data.status || null,
    current_period_start: toDate(data.current_period_start),
    current_period_end: toDate(data.current_period_end),
    canceled_at: toDate(data.canceled_at),
    cancel_at_period_end: !!data.cancel_at_period_end,
    schedule: data.schedule ? SubscriptionSchedule(data.schedule) : null,
  };
}

export function Purchase(data: Record<string, any> = {}) {
  return {
    stripe_session_id: data.stripe_session_id,
    created_at: data.created_at,
    credited_amount: data.credited_amount || 0,
    price: data.price || 0,
    stripe_price_id: data.stripe_price_id,
    stripe_product_id: data.stripe_product_id,
    stripe_product_price: data.stripe_product_price,
    stripe_product_currency: data.stripe_product_currency,
    stripe_product_description: data.stripe_product_description,
    stripe_product_quantity: data.stripe_product_quantity,
    price_currency: data.price_currency || 'EUR',
    credited_amount_currency: data.credited_amount_currency || 'EUR',
  };
}

export function DailyStatistic(data: Record<string, any> = {}) {
  return {
    date: data.date,
    api_calls: data.api_calls || 0,
    cost: data.cost || 0,
  };
}

export function ServiceSpend(data: Record<string, any> = {}) {
  return {
    service_id: data.service_id || null,
    service_name: data.service_name || null,
    service_created_by: data.service_created_by || null,
    third_party_provider: data.third_party_provider || null,
    total_cost: data.total_cost || 0,
    total_calls: data.total_calls || 0,
  };
}

export function SpendBreakdown(data: Record<string, any> = {}) {
  return {
    total_actual_cost: data.total_actual_cost || 0,
    total_actual_cost_currency: data.total_actual_cost_currency || 'EUR',
    daily_actual_cost_rate: data.daily_actual_cost_rate || 0,
    total_jobs: data.total_jobs || 0,
    finished_calls: data.finished_calls || 0,
    failed_calls: data.failed_calls || 0,
    timeout_calls: data.timeout_calls || 0,
    cancelled_calls: data.cancelled_calls || 0,
    unknown_calls: data.unknown_calls || 0,
    period_days: data.period_days || 30,
    daily_statistics: (data.daily_statistics || []).map(DailyStatistic),
    service_breakdown: (data.service_breakdown || []).map(ServiceSpend),
  };
}
